import { render, staticRenderFns } from "./DevicesForm.vue?vue&type=template&id=ef8a3548&scoped=true&"
import script from "./DevicesForm.vue?vue&type=script&lang=js&"
export * from "./DevicesForm.vue?vue&type=script&lang=js&"
import style0 from "./DevicesForm.vue?vue&type=style&index=0&id=ef8a3548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a3548",
  null
  
)

export default component.exports